import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { env } from "@environments/environment";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { DecryptedObject } from "@app/ui_models/crypto.model";

@Injectable({ providedIn: "root" })
export class CryptoController {

  public constructor(httpService: HttpClient) {
    this.httpService = httpService;
  }

  httpService: HttpClient;
  protected baseUrl = `${env.logisticsServiceBackend}/logistics/v1/signed/data`;

  public verify(signedData: string): Observable<DecryptedObject>  {
    const headers = new HttpHeaders().set("Content-type", "application/json");
    return this.httpService.post(`${this.baseUrl}/verified`, JSON.stringify(signedData), { headers, responseType: "text" }).pipe(map(res => (res ? JSON.parse(res) : undefined)));
  }
}
